import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Grid, Typography } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';

import { CheckoutSummaryProps } from './types';
import { Colors } from '../../utils/Colors';

const details: { header: string; body: string[] }[] = [
  {
    header: 'Compulsion Tracker',
    body: [
      'Track resists, submits, and competing responses associated with anunlimited number of compulsions'
    ]
  },
  {
    header: 'ERP Homework Tracker',
    body: [
      ' Digitize your ERP treatment plan as provided by your therapist',
      'Track progress against exercises including anxiety levels'
    ]
  },
  {
    header: 'Compulsion Response Analytics',
    body: [
      'View a weekly trend of submits, resists, and competing responses for each compulsion'
    ]
  },
  {
    header: 'GAD-7 Anxiety Survey',
    body: ['Complete a GAD-7 anxiety survey anytime and anywhere']
  },
  {
    header: 'Dashboard',
    body: [
      'View metrics associated with logged compulsion responses and GAD-7 anxiety scores'
    ]
  }
];

export const CheckoutSummary = ({
  borderTop = false,
  priceId,
  prices
}: CheckoutSummaryProps) => {
  const [durration, setDurration] = useState('');
  const {
    unit_amount: value,
    recurring,
    type
  } = useMemo(() => {
    if (priceId && prices.length > 0) {
      const subscription = prices.find((price: any) => price.id === priceId);
      if (subscription && subscription.unit_amount) return subscription;
    }
    return {
      recurring: undefined,
      type: 'recurring',
      unit_amount: 0
    };
  }, [priceId, prices]);

  useEffect(() => {
    if (recurring && recurring.interval) {
      if (recurring.interval === 'month') setDurration('Monthly');
      if (recurring.interval === 'year') setDurration('Annual');
    }
  }, [recurring]);

  return (
    <Box
      sx={{
        borderLeft: `${borderTop ? '' : `1px solid ${Colors.lightGray}`}`,
        borderTop: `${borderTop ? `1px solid ${Colors.lightGray}` : ``}`,
        height: '100%',
        margin: 'auto',
        marginTop: '5px',
        padding: 4,
        paddingTop: '25px',
        width: '90%'
      }}
    >
      <Typography variant="h5" fontWeight="700" sx={{ marginBottom: '20px' }}>
        What is Included
      </Typography>
      {details.map(({ header, body }) => (
        <Grid container direction="row" key={`grid-details-${header}`}>
          <Grid item xs={1}>
            <CheckCircleIcon sx={{ color: Colors.ocdGreen }} />
          </Grid>
          <Grid item xs={11}>
            <Typography variant="body1">{header}</Typography>
            {body.map((text, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Typography variant="caption" key={`${header}-text-${index}`}>
                {text}
                <br />
              </Typography>
            ))}
          </Grid>
        </Grid>
      ))}
      <Typography
        variant="h5"
        fontWeight="700"
        sx={{ marginBottom: '20px', marginTop: '20px' }}
      >
        Summary
      </Typography>
      <Grid container>
        <Grid item xs={6}>
          <Typography>
            {durration.length > 0 ? `${durration} Subscription` : ''}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          {value > 0 ? (
            <Typography sx={{ float: 'right' }}>
              {value / 100 > 0 ? '$' : ''}
              {(value / 100).toFixed(2)}
            </Typography>
          ) : null}
        </Grid>
        <Grid item xs={12}>
          {type === 'recurring' ? (
            <Typography variant="caption">Reoccuring payment</Typography>
          ) : null}
        </Grid>
        <Grid item xs={12}>
          <Box
            sx={{
              borderBottom: `1px solid ${Colors.lightGray}`,
              marginBottom: '20px',
              marginTop: '20px'
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <Typography variant="h6">Total</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="h6" sx={{ float: 'right' }}>
            {value / 100 > 0 ? '$' : ''}
            {(value / 100).toFixed(2)}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};
